import React from 'react';

import {
    Checkbox,
    FormControl,
    FormHelperText,
    InputLabel,
    ListItemText,
    MenuItem,
    Select,
} from '@sunwisesoftware/sunwise-ui';
import isArray from 'lodash/isArray';
import PropTypes from 'prop-types';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};

const ReduxFieldSelect = ({
    autoWidth,
    disabled,
    fullWidth = true,
    input: { value, onChange, onBlur },
    label,
    meta: { touched, error },
    multiple,
    options = [],
    readOnly,
    required,
    variant = 'filled',
    ...other
}) => {
    const onChangeAction = (event) => onChange(event);

    const onBlurAction = (event, blurValue) => {
        onBlur(event, blurValue);
    };

    return (
        <FormControl
            disabled={disabled}
            error={Boolean(touched && error)}
            fullWidth={fullWidth}
            required={required}
            size="small"
            variant={variant}
        >
            <InputLabel id={`redux-field-select-label`}>{label}</InputLabel>
            <Select
                autoWidth={autoWidth}
                displayEmpty={multiple}
                id={`redux-field-select`}
                inputProps={{ readOnly: readOnly }}
                label={label}
                labelId={`redux-field-select-label`}
                multiple={multiple}
                onBlur={onBlurAction}
                onChange={onChangeAction}
                value={value}
                renderValue={(selected) => {
                    if (isArray(selected)) {
                        if (selected.length > 0) {
                            let selectedOptionsLabel = [];
                            selected.forEach((s) => {
                                const opt = options.find(
                                    (o) => o.optionValue === s,
                                );
                                if (opt) selectedOptionsLabel.push(opt.label);
                            });
                            return selectedOptionsLabel.join(', ');
                        }
                    } else {
                        const opt = options.find(
                            (o) => o.optionValue === selected,
                        );
                        return opt ? opt.label : '';
                    }
                    return '';
                }}
                MenuProps={MenuProps}
                {...other}
            >
                {options.map(
                    ({ label, optionValue, disabled: optionDisabled }) => (
                        <MenuItem
                            key={`select-${optionValue}-${label}`}
                            value={optionValue}
                            disabled={optionDisabled}
                        >
                            {multiple ? (
                                <>
                                    <Checkbox
                                        checked={
                                            value.indexOf(optionValue) > -1
                                        }
                                    />
                                    <ListItemText primary={label} />
                                </>
                            ) : (
                                label
                            )}
                        </MenuItem>
                    ),
                )}
            </Select>
            <FormHelperText id={`redux-field-select-helper-text`}>
                {touched && error}
            </FormHelperText>
        </FormControl>
    );
};

ReduxFieldSelect.propTypes = {
    autoWidth: PropTypes.bool,
    disabled: PropTypes.bool,
    fullWidth: PropTypes.bool,
    input: PropTypes.object,
    label: PropTypes.string,
    meta: PropTypes.object,
    multiple: PropTypes.bool,
    options: PropTypes.array,
    readOnly: PropTypes.bool,
    required: PropTypes.bool,
    variant: PropTypes.string,
};

export default ReduxFieldSelect;
